var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Thanks")]),_c('div',{staticStyle:{"width":"300px","height":"300px","background-color":"green"}})])}]

export { render, staticRenderFns }